import { useState, useEffect, useCallback } from 'react';
import { get } from '../../../api/client';
import { useAuthStore } from '../../../stores/authStore';
import type { CustomerWithTags } from '../../../types';

// 类型别名，保持向后兼容
export type Customer = CustomerWithTags;

export function useCustomers() {
  const { profile } = useAuthStore();
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomers = useCallback(async () => {
    if (!profile?.id) return;
    setLoading(true);
    setError(null);
    try {
      // 调用后端 API 获取客户列表
      const customersData = await get<Customer[]>('/customers');
      if (!customersData) throw new Error('获取客户数据失败');

      setCustomers(customersData);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : '加载失败');
    } finally {
      setLoading(false);
    }
  }, [profile?.id]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return { customers, loading, error, refresh: fetchCustomers };
}
